import { inject, Pipe, PipeTransform } from '@angular/core';
import { ShieldLogsItemModel } from '@bn/app-shield';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu';
import { WafService } from '../../../services/waf.service';

@Pipe({
  name: 'getLogDropdownItems',
  standalone: true,
})
export class GetLogDropdownItemsPipe implements PipeTransform {
  readonly #wafService = inject(WafService);

  transform(log: ShieldLogsItemModel): DropdownMenuItem[] {
    // NOTE: Is this really right way of doing it?
    // Maybe we should check current rule status instead of status at the log timestamp?

    const blockingRuleItems = [
      {
        label: 'Disable rule',
        action: 'disable',
        id: log.labels.ruleId,
      },
      {
        label: 'Make rule log only',
        action: 'log',
        id: log.labels.ruleId,
      },
    ];

    const loggingRuleItems = [
      {
        label: 'Enable rule',
        action: 'enable',
        id: log.labels.ruleId,
      },
      {
        label: 'Disable rule',
        action: 'disable',
        id: log.labels.ruleId,
      },
    ];

    return this.#wafService.isRuleBlocking(log.labels.ruleId) ? blockingRuleItems : loggingRuleItems;
  }
}
